module.exports = __webpack_public_path__ + "img/MOUSTACHES 3.227e862.svg";